export default __webpack_public_path__ + "static/media/3.57ef97d1.jpeg";